"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _tabItem = _interopRequireDefault(require("../tab-item"));

var _excluded = ["children", "className", "orientation", "role", "selectedTab"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-tab';
var KEY_CODES = {
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  END: 35,
  HOME: 36
};
var TabList = (0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      orientation = _ref.orientation,
      role = _ref.role,
      selectedTab = _ref.selectedTab,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  ref = ref || (0, _react.useRef)();

  var _useState = (0, _react.useState)(selectedTab),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTabIndex = _useState2[0],
      setSelectedTabIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(selectedTabIndex),
      _useState4 = _slicedToArray(_useState3, 2),
      focusedIndex = _useState4[0],
      setFocusedIndex = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      focusableChildren = _useState6[0],
      setFocusChildren = _useState6[1];

  (0, _react.useEffect)(function () {
    setFocusChildren(Array.from(ref.current.querySelectorAll('li > .vds-tab:not(.vds-state--disabled)')));
  }, [children, ref]);
  (0, _react.useEffect)(function () {
    setSelectedTabIndex(selectedTab);
  }, [selectedTab]);

  var handleClick = function handleClick(e, k, child) {
    setSelectedTabIndex(k);
    setFocusedIndex(k);

    if (typeof child.props.onClick === 'function') {
      child.props.onClick(e, k);
    }
  };

  var handleKeyDown = function handleKeyDown(e, k, child) {
    var code = e.charCode || e.keyCode;
    var count = focusableChildren.length;
    var fIndex = focusedIndex || 0;

    switch (code) {
      case KEY_CODES.END:
        {
          e.preventDefault();
          setFocusedIndex(count - 1);
          return focusableChildren[count - 1].focus();
        }

      case KEY_CODES.HOME:
        {
          e.preventDefault();
          setFocusedIndex(0);
          return focusableChildren[0].focus();
        }

      case KEY_CODES.ARROW_LEFT:
      case KEY_CODES.ARROW_UP:
        {
          e.preventDefault();
          setFocusedIndex(fIndex - 1 < 0 ? count - 1 : fIndex - 1);
          return focusableChildren[fIndex - 1 < 0 ? count - 1 : fIndex - 1].focus();
        }

      case KEY_CODES.ARROW_RIGHT:
      case KEY_CODES.ARROW_DOWN:
        {
          e.preventDefault();
          setFocusedIndex((fIndex + 1) % count);
          return focusableChildren[(fIndex + 1) % count].focus();
        }

      default:
        break;
    }

    if (typeof child.props.onKeyDown === 'function') {
      child.props.onKeyDown(e, k);
    }

    return setFocusedIndex(selectedTabIndex);
  };

  return /*#__PURE__*/_react.default.createElement("ul", _extends({
    className: (0, _classnames2.default)("".concat(CSS_PREFIX, "-list"), _defineProperty({}, "".concat(CSS_PREFIX, "--").concat(orientation), Boolean(orientation)), className),
    ref: ref,
    role: role
  }, remainingProps), _react.Children.map(children, function (child, k) {
    return /*#__PURE__*/_react.default.createElement(_tabItem.default, {
      role: "none"
    }, (0, _react.cloneElement)(child, {
      key: k,
      onClick: function onClick(e) {
        return handleClick(e, k, child);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, k, child);
      },
      selected: selectedTabIndex === k,
      tabIndex: Number.isInteger(focusedIndex) ? focusedIndex === k ? 0 : -1 : k === 0 ? 0 : -1
    }));
  }));
});
TabList.propTypes = {
  /**
   * @ignore
   */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Orientation
   */
  orientation: (0, _propTypes.oneOf)(['vertical']),

  /**
   * @ignore
   */
  role: _propTypes.string,

  /**
   * Selected Tab Index
   */
  selectedTab: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
TabList.defaultProps = {
  role: 'tablist'
};
TabList.displayName = 'TabList';
var _default = TabList;
exports.default = _default;